export default __webpack_public_path__ + "static/media/sliderTest.f0f2c4f1.png";